import { User } from "@/models/user";
import { Payment } from "@/models/payment";
import { VoucherCategory } from "./voucherCategory";

export interface Voucher {
  id: number;
  voucherCode: string;
  categoryId?: number;
  partnerId?: number;
  reportId?: number;
  paymentId?: number;
  userId?: number;
  userUsedId?: number;
  status: STATUS_VOUCHER;
  source: SOURCE_VOUCHER;
  titlePartner?: string;
  titleCategory?: string;
  type: ETYPE_VOUCHER;
  typeAmount: TYPE_VOUCHER;
  expirationDate?: Date;
  amount?: number;
  usedDate?: Date;
  percent?: number;
  isNoExpiration: boolean;
  isExclusive: boolean;
  isAllowSharedPayment: boolean;
  user?: User;
  userUsed?: User;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  payment?: Payment;
  category: VoucherCategory;
}

export interface Voucher2 {
  id: number;
  voucherCode: string;
  typeAmount: TYPE_VOUCHER;
  stringValue: string;
  categoryId: number;
  amount: number;
  percent?: number;
  priceIDR?: string;
  priceUSD?: string;
  priceVND?: string;
  isExclusive: boolean;
  isMultipleUsePerUser?: boolean;
  isOneCodeForAll: boolean;
  quantity?: number;
  quantityUsed?: number;
  isAllowSharedPayment: boolean;
}

export interface voucherCreate {
  type: number;
  quantity: number;
  idGenerate: number;
}

export enum TYPE_VOUCHER {
  FLAT = 1,
  PERCENTAGE,
}

export interface checkExitsVoucher {
  projectId: number;
  code: string;
}

export enum STATUS_VOUCHER {
  ENABEL = 1,
  DISABEL,
  USED,
}

export enum SOURCE_VOUCHER {
  ADMIN,
  USER_REGISTER,
}

export enum ETYPE_VOUCHER {
  CATEGRORY = 1,
  REFERRER,
}

export const typeVouchers = [
  {
    id: 1,
    name: "Category",
  },
  {
    id: 2,
    name: "Referer",
  },
];

export interface CheckVoucher {
  subscriptionId?: number;
  reportId?: number;
  subscriptionIds?: number[];
  reportIds?: number[];
  code: string;
}

export interface UpdateStatusVoucher {
  status: number;
}
